module.exports = __webpack_public_path__ + "assets/img/20.55da7746.png";